var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dialogContainer"},[_c('el-dialog',{attrs:{"title":_vm.title,"width":_vm.width,"modal":true,"center":"","destroy-on-close":true,"visible":_vm.visible},on:{"close":_vm.handleClose}},[_vm._t("default"),_c('span',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"})],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }